import {
  informerFatcaStatusNFFEOption1,
  informerFatcaStatusNFFEOption2,
} from '~/modules/identification/forms/FatcaAdditionalInformation/constants/informers.tsx';
import { ClientTypes } from '~/constants/clientTypes.ts';
import { TFatcaAdditionalInformation } from '~/modules/identification/forms/FatcaAdditionalInformation/types.ts';

export enum FatcaStatus {
  SPECIFIED_US_PERSON = 'SPECIFIED_US_PERSON',
  NOT_SPECIFIED_US_PERSON = 'NOT_SPECIFIED_US_PERSON',
}

export enum FatcaStatusFFI {
  REPORTING_MODEL_1_FFI = 'REPORTING_MODEL_1_FFI',
  REPORTING_MODEL_2_FFI = 'REPORTING_MODEL_2_FFI',
  REGISTERED_DEEMED_COMPLIANT_FFI = 'REGISTERED_DEEMED_COMPLIANT_FFI',
  NONPARTICIPATING_FFI = 'NONPARTICIPATING_FFI',
  OTHER = 'OTHER',
}

export enum FatcaStatusNFFE {
  ACTIVE_NFFE = 'ACTIVE_NFFE',
  PASSIVE_NFFE_WITH_SUBSTANTIAL_US_OWNERS = 'PASSIVE_NFFE_WITH_SUBSTANTIAL_US_OWNERS',
  OTHER = 'OTHER',
}

export const FatcaStatusOptions = [
  {
    value: FatcaStatus.SPECIFIED_US_PERSON,
    label:
      'Відзначте, в разі, якщо Ваша установа відноситься до зазначених американських осіб відповідно до закону FATCA (Specified U.S. Person)',
  },
  {
    value: FatcaStatus.NOT_SPECIFIED_US_PERSON,
    label:
      'Відзначте, в разі, якщо Ваша установа НЕ відноситься до зазначених американських осіб відповідно до закону FATCA (NOT a Specified U.S. Person)',
  },
];

export const FatcaStatusFFIOptions = [
  {
    value: FatcaStatusFFI.REPORTING_MODEL_1_FFI,
    label: 'Reporting Model 1 FFI (іноземна фінансова установа, що звітує згідно Моделі 1)',
  },
  {
    value: FatcaStatusFFI.REPORTING_MODEL_2_FFI,
    label: 'Reporting Model 2 FFI (іноземна фінансова установа, що звітує згідно Моделі 2)',
  },
  {
    value: FatcaStatusFFI.REGISTERED_DEEMED_COMPLIANT_FFI,
    label:
      'Registered Deemed Compliant FFI (зареєстрована іноземна фінансова установа, яка вважається такою, що виконує вимоги)',
  },
  {
    value: FatcaStatusFFI.NONPARTICIPATING_FFI,
    label:
      'Nonparticipating Financial Institution (іноземна фінансова установа, яка не бере участь)',
  },
  {
    value: FatcaStatusFFI.OTHER,
    label: 'Інший FATCA-статус іноземної фінансової установи',
  },
];

export const FatcaStatusNFFEOptions = [
  {
    value: FatcaStatusNFFE.ACTIVE_NFFE,
    label: "Активний нефінансовий іноземний суб'єкт господарювання (Active NFFE)",
    informer: informerFatcaStatusNFFEOption1,
  },
  {
    value: FatcaStatusNFFE.PASSIVE_NFFE_WITH_SUBSTANTIAL_US_OWNERS,
    label:
      "Пасивний нефінансовий іноземний суб'єкт господарювання з контролюючими особами / власниками істотної участі США (Passive NFFE with substantial U.S. Owner(s))",
    informer: informerFatcaStatusNFFEOption2,
  },
  {
    value: FatcaStatusNFFE.OTHER,
    label: 'Інший FATCA-статус',
    informer: informerFatcaStatusNFFEOption1,
  },
];

export const shuwGiinFatcaStatusFFI = [
  FatcaStatusFFI.REPORTING_MODEL_1_FFI,
  FatcaStatusFFI.REPORTING_MODEL_2_FFI,
  FatcaStatusFFI.REGISTERED_DEEMED_COMPLIANT_FFI,
  FatcaStatusFFI.OTHER,
];

export const EMPTY_SUBSTANTIAL_US_OWNERS = {
  id: null,
  lastName: null,
  firstName: null,
  middleName: null,
  lastNameEng: null,
  firstNameEng: null,
  middleNameEng: null,
  tin: null,
  countryEng: null,
  cityEng: null,
};

export const EMPTY_FATCA_ADDITIONAL_INFORMATION: TFatcaAdditionalInformation = {
  usEntityInfo: {
    clientFullName: null,
    clientFullNameEng: null,
    tinEin: null,
    fatcaStatus: null,
  },
  foreignFinancialInstitutionInfo: {
    clientFullName: null,
    fatcaStatusFFI: null,
    otherFatcaStatusFFI: null,
    giin: null,
  },
  nffeInfo: {
    fatcaStatusNFFE: null,
    otherFatcaStatusNFFE: null,
    substantialUSOwners: null,
  },
  type: ClientTypes.LEGAL_RESIDENT,
  isCompleted: false,
};
